﻿// Tours hidden from the Radical Dashboard. Only HEX and HAG ask for the list - every other brand gets an empty one.
// The list is shared by every component and refreshed at most once a minute. Only an explicit is_active === false
// hides a tour; if the dashboard can't be reached (error, timeout, bad response) nothing is hidden.
const Refresh_Ms = 60 * 1000;
const Timeout_Ms = 3000;

let Hidden_Codes: Set<string> = new Set<string>();
let Loaded_At = 0;
let Loading: Promise<Set<string>> | null = null;

export class Hidden_Tours {

    public Is_Dashboard_Brand(): boolean {
        const brand = String(import.meta.env.VITE_DEFAULT_CLASS ?? "").trim().toUpperCase();
        return brand == "HEX" || brand == "HAG";
    }
    // Loads the list (or reuses it if it's under a minute old). Never rejects.
    public async Load(): Promise<Set<string>> {
        if (Loaded_At > 0 && Date.now() - Loaded_At < Refresh_Ms) {
            return Hidden_Codes;
        }

        if (Loading == null) {
            Loading = this.Fetch().then(codes => {
                Hidden_Codes = codes;
                Loaded_At = Date.now();
                Loading = null;
                return codes;
            });
        }

        return Loading;
    }
    // Checks against the last loaded list, so call Load first.
    public Is_Hidden(tour_id: string | null | undefined): boolean {
        return Hidden_Codes.has(this.Normalise(tour_id));
    }
    public Without_Hidden<T extends { tour_id: string }>(products: T[]): T[] {
        if (products == undefined || Hidden_Codes.size == 0) {
            return products ?? [];
        }

        return products.filter(product => !this.Is_Hidden(product?.tour_id));
    }
    private Normalise(tour_id: string | null | undefined): string {
        return (tour_id ?? "").toString().trim().toUpperCase();
    }
    private async Fetch(): Promise<Set<string>> {
        const codes = new Set<string>();
        if (!this.Is_Dashboard_Brand()) {
            return codes;
        }

        const apiUrl = import.meta.env.VITE_DASHBOARD_API_URL;
        const apiKey = import.meta.env.VITE_DASHBOARD_API_KEY;
        if (!apiUrl || !apiKey) {
            return codes;
        }

        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), Timeout_Ms);

        try {
            const response = await fetch(`${apiUrl}/admin/tours/hidden`, {
                headers: { 'X-Api-Key': apiKey },
                signal: controller.signal
            });
            if (!response.ok) {
                return codes;
            }

            const data = await response.json();
            if (!Array.isArray(data)) {
                return codes;
            }

            data.forEach((tour: { tour_code?: string, is_active?: boolean }) => {
                const code = this.Normalise(tour?.tour_code);
                if (tour?.is_active === false && code != "") {
                    codes.add(code);
                }
            });
            return codes;
        } catch {
            // nothing is hidden on error
            return new Set<string>();
        } finally {
            clearTimeout(timer);
        }
    }
}
